module.exports = __webpack_public_path__ + "img/locked.1f6cfe92.svg";